module.exports = __webpack_public_path__ + "img/720cece4-e250-4984-b544-ba833a3384ac.97eff138.jpg";